import * as stylex from "@stylexjs/stylex";
import React from "react";
import { colors } from "../materials/consts.stylex";
import { typography } from "../materials/typography.stylex";
const styles = {
    title: {
        k63SB2: "x117nqv4",
        kMwMTN: "xjvpvmj",
        k1K539: "x1e56ztr",
        $$css: true
    },
    body: {
        kMwMTN: "xjvpvmj",
        k1K539: "x1e56ztr",
        $$css: true
    },
    source: {
        k1K539: "xod5an3",
        $$css: true
    },
    sourceText: {
        kMwMTN: "x196nufh",
        $$css: true
    }
};
export function InteractiveTooltip({ children, content }) {
    const rawId = React.useId();
    const sanitizedId = rawId.replace(/:/g, "");
    const popoverId = `interactive-popover-${sanitizedId}`;
    const anchorName = `--popover-anchor-${sanitizedId}`;
    const trigger = React.cloneElement(children, {
        popoverTarget: popoverId,
        popoverTargetAction: "toggle",
        style: {
            ...children.props.style,
            anchorName
        }
    });
    const panelProps = {
        className: "x1oin6zd xc342km xng3xce x3isg7e x1rea2x4 x1anvkwx x1glncm5 x14vqqas x1jzhcrs x398du x12peec7 x1cum3z5 x16cjn02"
    };
    const arrowProps = {
        className: "xixxii4 xnalus7 xqtp20y x1y0btm7 x9r1u3d x1eoefnw x6h9yrm x47corl"
    };
    return <>
      {trigger}
      <div id={popoverId} popover="auto" {...panelProps} style={{
        ...panelProps.style,
        positionAnchor: anchorName
    }}>
        <div {...arrowProps} style={{
        ...arrowProps.style,
        positionAnchor: anchorName,
        left: `calc(anchor(${anchorName} center) - 8px)`,
        top: `calc(anchor(${anchorName} bottom) - 4px)`
    }}/>
        <div className="x78zum5 xdt5ytf">
          {content.map(({ title, body, source }, i)=><React.Fragment key={i}>
              <h2 {...stylex.props(typography.lead2, styles.title)}>{title}</h2>
              <div {...stylex.props(typography.table, styles.body)}>{body}</div>
              {source && <div {...stylex.props(typography.axis, styles.source, styles.sourceText)}>
                  <small {...stylex.props(typography.axis, styles.sourceText)}>{source}</small>
                </div>}
            </React.Fragment>)}
        </div>
      </div>
    </>;
}
